module.exports = __webpack_public_path__ + "static/ux_6_3_eg-924bfb210fe5968047bd79ef1219f1ca.png";